import { Avatar, Box, Button, Typography } from '@mui/material'
import { InsertDriveFileOutlined as FileAttachmentIcon } from '@mui/icons-material'

export default function FileDropzoneEmptyState({ fileType }: { fileType?: string }): JSX.Element {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
            }}
        >
            <Button
                size='large'
                variant='outlined'
                color='secondary'
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mt: 1,
                }}
            >
                <Avatar sx={{ mr: 2 }}>
                    <FileAttachmentIcon />
                </Avatar>
                Browse
            </Button>

            <Typography variant='caption' color='textSecondary' component='p' sx={{ mt: 1 }}>
                {`or drop ${fileType} file`}
            </Typography>
        </Box>
    )
}
